// extracted by mini-css-extract-plugin
module.exports = {"featuredHeader":"FeaturedHeader_featuredHeader__bufR_","header":"FeaturedHeader_header__WCB2I"};